import React, { useState, useEffect, useContext, useRef } from 'react';
import { Redirect } from 'react-router';
import { useHistory } from 'react-router-dom';

import { useForm } from 'react-hook-form';

import useToast from 'components/Additional/Toast/useToast';
import SfiLoader from 'components/Additional/SfiLoader/SfiLoader';
import CustomSelect from 'components/Additional/CustomSelect/CustomSelect';
import CustomInput from 'components/Additional/CustomInput/CustomInput';
import PageTitle from 'components/Additional/PageElements/PageTitle/PageTitle';
import Footer from 'components/Additional/Footer/Footer';
import ErrorMessage from 'components/Additional/ErrorMessage/ErrorMessage';
import BottomNavigation from 'components/Additional/BottomNavigation/BottomNavigation';
import DidYouKnow from 'components/Additional/DidYouKnow/DidYouKnow';
import CustomLabel from 'components/Additional/CustomLabel/CustomLabel';
import ImageButton from './ImageButton';
import {
	updateQuote,
	createActivityQuoteDB,
	getProductCoderef,
} from '../API/Model';
import { AppContext } from 'context/app-context/AppContext';
import Navigation from '../Overlays/Navigation';

import {
	saveQuoteToCreateData,
	getQuoteToCreateData,
} from 'tools/LocalStorageHelper';

import styles from './PropertyInfo_page.module.css';
import 'components/styles/styles.css';

function PropertyInfo_page() {
	const PAGE_NAME = 'PropertyInfo';
	const page = 2;
	let history = useHistory();

	const contactEmail = useRef(localStorage.getItem('brand_email'));

	const {
		updateQuoteData,
		fetchQuoteAndLog,
		setDTOBuildingField,
		setDTOBuildingDefaults,
		setDTOBuildingDefaultsForCpecificPolicyType,
		setDTOBasicPolicyDefaultsForSpecificPolicyType,
	} = useContext(AppContext);
	const { showToast, hideToast } = useToast();
	const {
		register,
		formState: { errors },
		handleSubmit,
		setValue,
		setError,
		clearErrors,
		trigger,
	} = useForm({ shouldUnregister: false });

	const [quote_information, setquote_information] = useState(0);
	const [submitLoading, setsubmitLoading] = useState(false);
	const [load, setonLoad] = useState(false);
	const [count_full, setCount_full] = useState(0);
	const [count_half, setCount_half] = useState(0);
	const [foundationType, set_foundationType] = useState(0);
	const [roofShape, set_RoofShape] = useState(null);
	const [roofMaterial, set_RoofMaterial] = useState(null);
	const [cov_a_limit, set_cov_a_limit] = useState(0);
	const [cov_c_limit, set_cov_c_limit] = useState(0);
	const [general_cov_a_limit, set_general_cov_a_limit] = useState(0);
	const [newQuoteEmailSent, setNewQuoteEmailSent] = useState(false);
	const [options, setOptions] = useState(null);
	const [roofShapeError, setRoofShapeError] = useState(null);
	const [roofMaterialError, setRoofMaterialError] = useState(null);
	const [fetchQuoteError, setFetchQuoteError] = useState(false);

	let quote = {
		ApplicationNumber:
			'"' + window.localStorage.getItem('quote_number') + '"',
		Owner: 'SalesPortal',
	};

	const forbiddenRoofMaterial = 'Wood Shingle';
	const forbiddenRoofMaterial2 = 'Asbestos';

	useEffect(() => {
		async function fetchData() {
			const response = await fetchQuoteAndLog(PAGE_NAME);
			if (response === 'Error') {
				setFetchQuoteError(true);
				return;
			}

			setquote_information({
				ExternalValidateBeanExist: 'No',
				DTOApplication: [response],
			});
		}

		async function fetchCoderefs() {
			try {
				const productVersion = localStorage.getItem('product_version');
				const policyType = localStorage.getItem('policy_type');
				const key = 'all';
				let numStoriesKey = 'all';
				if (policyType === 'HO6') {
					numStoriesKey = 'building';
				}
				const [constructionRes, structureTypeRes, numberStoriesRes] =
					await Promise.all([
						getProductCoderef(
							'construction-type',
							key,
							productVersion
						),
						getProductCoderef(
							'structure-type',
							key,
							productVersion
						),
						getProductCoderef(
							'number-stories',
							numStoriesKey,
							productVersion
						),
					]);

				let constructionOptions =
					constructionRes.coderef[0].options[0].option;
				constructionOptions = constructionOptions.map((option) => {
					if (option.value === 'Superior') {
						option.name = 'Superior (100% Concrete Roof and Walls)';
					} else if (option.value === 'Log') {
						option.name = 'Log Home';
					}
				});

				let structureOptions =
					structureTypeRes.coderef[0].options[0].option;
				structureOptions = structureOptions.filter(
					(option) =>
						option.name === 'Single Family House' ||
						option.name === 'Townhouse' ||
						option.name === 'Duplex' ||
						option.name === 'Condo - 2 to 4 Units' ||
						option.name === 'Apartments - 2 to 4 Units'
				);
				structureTypeRes.coderef[0].options[0].option =
					structureOptions;

				structureOptions = structureOptions.map((option) => {
					if (option.value === 'Condo - 2 to 4 Units') {
						option.name = 'Condominium';
					} else if (option.value === 'Apartments - 2 to 4 Units') {
						option.name = 'Apartment';
					}
				});
				const optionsData = {
					constructionTypeOptions:
						constructionRes.coderef[0].options[0].option,
					structureTypeOptions:
						structureTypeRes.coderef[0].options[0].option,
					numberStoriesOptions:
						numberStoriesRes.coderef[0].options[0].option,
				};

				setOptions(optionsData);
			} catch (error) {
				console.error('Error fetching product code refs:', error);
			}
		}

		(async () => {
			await fetchCoderefs();
			await fetchData();
		})();
	}, []);

	useEffect(() => {
		if (quote_information.ExternalValidateBeanExist != undefined) {
			if (load === false) {
				createActivityQuoteDB(
					'PropertyInfo',
					'PL',
					'PropertyInfo page loaded'
				);
				localStorage.setItem('current_page', 'PropertyInfo');
				let families = 1;
				if (
					quote_information.DTOApplication[0].DTOLine[0].DTORisk[0]
						.DTOBuilding[0].NumberOfFamily !== undefined
				) {
					families =
						quote_information.DTOApplication[0].DTOLine[0]
							.DTORisk[0].DTOBuilding[0].NumberOfFamily;
				}

				setValue('families', families);

				//update HazardHub info
				if (
					window.localStorage.getItem('hazard_hub_data_used') ===
						'no' &&
					window.localStorage.getItem('hazard_hub_data') === 'yes'
				) {
					const quoteInfo = JSON.parse(
						localStorage.getItem('quote_information')
					);
					let numberOfStories, sqFt, yearBuilt, contructionCd;

					if (
						quoteInfo.num_stories !== 'null' &&
						parseInt(quoteInfo.num_stories) > 3
					) {
						numberOfStories = '4+';
					} else if (quoteInfo.num_stories !== 'null') {
						numberOfStories = quoteInfo.num_stories;
					} else {
						numberOfStories = '0';
					}
					if (quoteInfo.sqft !== 'null') {
						sqFt = quoteInfo.sqft;
					} else {
						sqFt = '';
					}
					if (quoteInfo.build_year !== 'null') {
						yearBuilt = quoteInfo.build_year;
					} else {
						yearBuilt = '';
					}
					if (quoteInfo.construction_type !== 'null') {
						let hasConstructionType = false;
						options.constructionTypeOptions.forEach(function (
							option
						) {
							if (option.value === quoteInfo.construction_type)
								hasConstructionType = true;
						});
						if (hasConstructionType)
							contructionCd = quoteInfo.construction_type;
						else contructionCd = '0';
					} else {
						contructionCd = '0';
					}

					quote_information.DTOApplication[0].DTOLine[0].DTORisk[0].DTOBuilding[0].NumberOfStories =
						numberOfStories;
					quote_information.DTOApplication[0].DTOLine[0].DTORisk[0].DTOBuilding[0].SqFt =
						sqFt;
					quote_information.DTOApplication[0].DTOLine[0].DTORisk[0].DTOBuilding[0].YearBuilt =
						yearBuilt;
					quote_information.DTOApplication[0].DTOLine[0].DTORisk[0].DTOBuilding[0].ConstructionCd =
						contructionCd;
				}

				window.localStorage.setItem(
					'quote_information',
					JSON.stringify({
						firstYearPremium:
							quote_information.DTOApplication[0]
								.DTOBasicPolicy[0].FinalPremiumAmt,
						secondYearPremium:
							quote_information.DTOApplication[0].DTOLine[0]
								.EstimatedSecondYearAssessment,
						fiveYearPremium:
							quote_information.DTOApplication[0].DTOLine[0]
								.EstimatedFiveYearAveAnnualCost,
						num_stories:
							quote_information.DTOApplication[0].DTOLine[0]
								.DTORisk[0].DTOBuilding[0].NumberOfStories,
						sqft: quote_information.DTOApplication[0].DTOLine[0]
							.DTORisk[0].DTOBuilding[0].SqFt,
						build_year:
							quote_information.DTOApplication[0].DTOLine[0]
								.DTORisk[0].DTOBuilding[0].YearBuilt,
						found_type:
							quote_information.DTOApplication[0].DTOLine[0]
								.DTORisk[0].DTOBuilding[0].FoundationType,
						num_family: families,
						construction_type:
							quote_information.DTOApplication[0].DTOLine[0]
								.DTORisk[0].DTOBuilding[0].ConstructionCd,
					})
				);

				//basic information
				try {
					set_foundationType(
						quote_information.DTOApplication[0].DTOLine[0]
							.DTORisk[0].DTOBuilding[0].FoundationType
					);
					set_cov_a_limit(
						parseCurrency(
							quote_information.DTOApplication[0].DTOLine[0]
								.DTORisk[0].DTOBuilding[0].CovALimit
						)
					);
					set_cov_c_limit(
						parseCurrency(
							quote_information.DTOApplication[0].DTOLine[0]
								.DTORisk[0].DTOBuilding[0].CovCLimit
						)
					);

					setValue(
						'numberStories',
						quote_information.DTOApplication[0].DTOLine[0]
							.DTORisk[0].DTOBuilding[0].NumberOfStories ?? '0'
					);
					setValue(
						'SquareFoot',
						quote_information.DTOApplication[0].DTOLine[0]
							.DTORisk[0].DTOBuilding[0].SqFt ?? null
					);
					setValue(
						'YearofCons',
						quote_information.DTOApplication[0].DTOLine[0]
							.DTORisk[0].DTOBuilding[0].YearBuilt ?? null
					);
					setValue(
						'structureType',
						quote_information.DTOApplication[0].DTOLine[0]
							.DTORisk[0].DTOBuilding[0].StructureType ?? '0'
					);
					setValue(
						'constructionType',
						quote_information.DTOApplication[0].DTOLine[0]
							.DTORisk[0].DTOBuilding[0].ConstructionCd ?? '0'
					);
					setValue(
						'YearRoofBuilt',
						quote_information.DTOApplication[0].DTOLine[0]
							.DTORisk[0].DTOBuilding[0].YearRoofBuilt ?? null
					);
				} catch (e) {
					console.log('Error with fetching basic information');
				}

				//roof construction materials
				try {
					const roofMaterialMappingObject = {
						'Shingles: Asphalt or Composition':
							'Asphalt (Composition)',
						'Shingles: Architectural/Dimensional':
							'Asphalt (Composition)',
						'Tile: Flat Slate': 'Slate',
						'Shingles: Wood or Wood Shake': 'Wood Shingle ',
						'Shingles: Metal': 'Tin (Includes Copper and Steel)',
						'Tile: Flat Concrete, Clay or Composite':
							'Tile (Clay and Hendrix)',
						TPO: 'Tar and Gravel',
						Asbestos: 'Asbestos',
						Other: 'Other (Roof)',
					};

					if (
						quote_information.DTOApplication[0].DTOLine[0]
							.DTORisk[0].DTOBuilding[0].RoofCd
					) {
						const mappedRoofMaterial =
							roofMaterialMappingObject[
								quote_information.DTOApplication[0].DTOLine[0]
									.DTORisk[0].DTOBuilding[0].RoofCd
							];
						set_RoofMaterial(mappedRoofMaterial);
					}
				} catch (e) {
					console.log(
						'Error with roof/construction materials information'
					);
				}

				//roof shape
				try {
					if (
						quote_information.DTOApplication[0].DTOLine[0]
							.DTORisk[0].DTOBuilding[0].RoofShape
					) {
						const roofShape =
							quote_information.DTOApplication[0].DTOLine[0]
								.DTORisk[0].DTOBuilding[0].RoofShape;
						set_RoofShape(roofShape);
					}
				} catch (e) {
					console.log('Error with roof shape information');
				}

				setonLoad(true);
			}
		}
	}, [quote_information]);

	useEffect(() => {
		console.log('errors', errors);
	}, [errors]);

	const validateAndSubmit = async (event) => {
		event.preventDefault();
		let roofError = false;

		if (roofShape === null) {
			setRoofShapeError('Field is required *');
			roofError = true;
		} else {
			setRoofShapeError(null);
		}

		if (roofMaterial === null) {
			setRoofMaterialError('Field is required *');
			roofError = true;
		} else {
			setRoofMaterialError(null);
		}

		if (roofError) {
			await trigger();
			return;
		}

		const isValid = await trigger();
		if (isValid) {
			handleSubmit(onSubmit)();
		}
	};

	const onSubmit = async (data) => {
		const {
			numberStories,
			SquareFoot,
			YearofCons,
			YearRoofBuilt,
			structureType,
			constructionType,
			families,
		} = data;
		const quoteType = localStorage.getItem('policy_type');

		setsubmitLoading(true);
		createActivityQuoteDB('PropertyInfo', 'NAV', 'Continue button');

		const dtoBasicPolicy =
			quote_information.DTOApplication[0].DTOBasicPolicy[0];
		const dtoBuilding =
			quote_information.DTOApplication[0].DTOLine[0].DTORisk[0]
				.DTOBuilding[0];
		const qtrData = getQuoteToCreateData();
		const qtrDTOBuilding =
			qtrData.DTOApplication[0].DTOLine[0].DTORisk[0].DTOBuilding[0];

		const updatedProperties = [];
		const updateDTOBuilding = (propertyName, value) => {
			dtoBuilding[propertyName] = value;
			qtrDTOBuilding[propertyName] = value;
			updatedProperties.push(propertyName);
		};

		setDTOBuildingField(
			'NumberOfStories',
			numberStories,
			dtoBuilding,
			qtrDTOBuilding
		);
		setDTOBuildingField('SqFt', SquareFoot, dtoBuilding, qtrDTOBuilding);
		setDTOBuildingField(
			'YearBuilt',
			YearofCons,
			dtoBuilding,
			qtrDTOBuilding
		);

		const currentYear = new Date().getFullYear();
		if (currentYear - YearofCons <= 5 && cov_a_limit >= 400000) {
			const quoteTypes = JSON.parse(
				localStorage.getItem('applicableQuoteTypes')
			);
			if (!quoteTypes.includes('HO5')) {
				const ho3Index = quoteTypes.indexOf('HO3');
				if (ho3Index !== -1) {
					quoteTypes.splice(ho3Index + 1, 0, 'HO5');
				} else {
					quoteTypes.unshift('HO5');
				}
				localStorage.setItem(
					'applicableQuoteTypes',
					JSON.stringify(quoteTypes)
				);
			}
		}

		setDTOBuildingField(
			'FoundationType',
			foundationType,
			dtoBuilding,
			qtrDTOBuilding
		);
		if (quoteType === "HO4") {
			setDTOBuildingField(
				'CovCLimit',
				cov_c_limit,
				dtoBuilding,
				qtrDTOBuilding
			);
		} else {
			setDTOBuildingField(
				'CovALimit',
				cov_a_limit,
				dtoBuilding,
				qtrDTOBuilding
			);
		}
		setDTOBuildingField(
			'StructureType',
			structureType,
			dtoBuilding,
			qtrDTOBuilding
		);
		setDTOBuildingField(
			'NumFamilies',
			families,
			dtoBuilding,
			qtrDTOBuilding
		);
		setDTOBuildingField(
			'ConstructionCd',
			constructionType,
			dtoBuilding,
			qtrDTOBuilding
		);
		setDTOBuildingField(
			'YearRoofBuilt',
			YearRoofBuilt,
			dtoBuilding,
			qtrDTOBuilding
		);

		const policyType = localStorage.getItem('policy_type');
		const roofMaterialMappingObject = {
			'Asphalt (Composition)':
				policyType === 'HO5'
					? 'Shingles: Architectural/Dimensional'
					: 'Shingles: Asphalt or Composition',
			Slate: 'Tile: Flat Slate',
			'Wood Shingle': 'Shingles: Wood or Wood Shake',
			'Tin (Includes Copper and Steel)': 'Shingles: Metal',
			'Tile (Clay and Hendrix)': 'Tile: Flat Concrete, Clay or Composite',
			'Tar and Gravel': 'TPO',
			'Rubber Lining': 'Other',
			Asbestos: 'Asbestos',
			'Other (Roof)': 'Other',
		};

		const mappedRoofMaterial = roofMaterialMappingObject[roofMaterial];
		setDTOBuildingField(
			'RoofCd',
			mappedRoofMaterial,
			dtoBuilding,
			qtrDTOBuilding
		);

		setDTOBuildingField(
			'RoofShape',
			roofShape,
			dtoBuilding,
			qtrDTOBuilding
		);

		// DEFAULTS
		setDTOBuildingDefaults(dtoBuilding, qtrDTOBuilding);
		setDTOBuildingDefaultsForCpecificPolicyType(
			policyType,
			dtoBuilding,
			qtrDTOBuilding
		);
		setDTOBasicPolicyDefaultsForSpecificPolicyType(
			policyType,
			dtoBasicPolicy
		);
		saveQuoteToCreateData(qtrData);

		createActivityQuoteDB(
			'PropertyInfo',
			'API_REQ',
			'PropertyInfo update quote request'
		);

		if (quoteType === "HO3") {
			setDTOBuildingField(
				'WaterDamageCov',
				"Standard",
				dtoBuilding,
				qtrDTOBuilding
			);

			setDTOBuildingField(
				'WaterDed',
				"1000",
				dtoBuilding,
				qtrDTOBuilding
			);
		} 

		const quoteInformationString = JSON.stringify(quote_information);
		const response = await updateQuote(quoteInformationString);
		createActivityQuoteDB(
			'PropertyInfo',
			'API_RES',
			'PropertyInfo update quote response - ' + response
		);

		window.localStorage.setItem('hazard_hub_data_used', 'yes');
		history.push('/Discounts');
	};

	useEffect(() => {
		if (
			roofMaterial === forbiddenRoofMaterial ||
			roofMaterial === forbiddenRoofMaterial2
		) {
			showToast(
				'We do not accept these forms of roofing material. Please make a different selection in order to continue with this quote.',
				'Error',
				null
			);
		} else {
			hideToast();
		}
	}, [roofMaterial]);

	function parseCurrency(str) {
		return str ? parseInt(str.replace(/\D/g, '')) : null;
	}

	const changeRoofShapeState = (event) => {
		set_RoofShape(event.target.name);
	};

	const changeRoofMaterialState = (event) => {
		if (event.target.name === 'Other (Roof)') {
			set_RoofMaterial('Other (Roof)');
		} else {
			set_RoofMaterial(event.target.name);
		}
	};

	function onBackButtonClick() {
		createActivityQuoteDB('PropertyInfo', 'NAV', 'Back button');
	}

	const mapSelectOptions = (stateOptions) => {
		return stateOptions.map(({ value, name }) => {
			return {
				value,
				name,
			};
		});
	};

	const errorMessageComponent = (
		<div
			style={{
				height: '60vh',
				display: 'flex',
				alignItems: 'center',
			}}
		>
			<ErrorMessage
				contactEmail={contactEmail.current}
				phoneNumber={window.APP_CONFIG.CONTACT_PHONE}
			/>
		</div>
	);

	if (localStorage.getItem('status') === 'COMP') {
		return <Redirect push to={'/Coverages'} />;
	}

	if (fetchQuoteError) return errorMessageComponent;

	return (
		<div className="base-wrapper">
			<div className="abs-wrapper">
				<Navigation page={page} progress={2} />
			</div>
			{submitLoading ? (
				<DidYouKnow title="Updating your estimate" />
			) : options === null ? (
				<div className={styles['internal-loader']}>
					<SfiLoader />
				</div>
			) : (
				<div className={styles.propertyinfo_wrapper}>
					<div className={styles.propertyinfo_content_wrapper}>
						<PageTitle titleContent={<>Property Information</>} />
						<form onSubmit={validateAndSubmit}>
							<div className={styles.contentBox_p4}>
								<div className="p4_c1_r0">
									{localStorage.getItem('hazard_hub_data') ===
									'yes' ? (
										<p className={styles.hazard_hub_info}>
											We found some information about your
											home using Public Records. Please
											make any necessary corrections and
											fill in any remaining information.
										</p>
									) : (
										<></>
									)}
								</div>
								<CustomSelect
									label="# of Stories"
									name="numberStories"
									options={mapSelectOptions(
										options.numberStoriesOptions
									)}
									ref={register({
										validate: (value) =>
											value !== '0' ||
											'Field is required *',
									})}
									error={errors.numberStories?.message}
									customContainerClass="p4_c1_r1"
								/>
								<div className="p4_c2_r1">
									<CustomInput
										inputName="SquareFoot"
										inputLabel="Square Footage"
										placeholder="Enter #"
										tooltip="This includes the finished square footage of the home above ground, not including finished basements."
										error={
											errors.SquareFoot &&
											errors.SquareFoot.message
										}
										onInput={(e) => {
											e.target.value =
												e.target.value.replace(
													/\D/g,
													''
												);
											if (e.target.value.length > 4) {
												e.target.value =
													e.target.value.slice(0, 4);
											}
										}}
										ref={register({
											validate: (value) => {
												if (
													value === '0' ||
													value === ''
												)
													return 'Field is required *';
											},
										})}
									/>
								</div>
								<div className="p4_c3_r1">
									<CustomInput
										inputName="YearofCons"
										inputLabel="Year of Construction"
										placeholder="1900"
										type="number"
										error={
											errors.YearofCons &&
											errors.YearofCons.message
										}
										onInput={(e) => {
											e.target.value =
												e.target.value.replace(
													/\D/g,
													''
												);
											if (e.target.value.length > 4) {
												e.target.value =
													e.target.value.slice(0, 4);
											}
										}}
										ref={register({
											validate: (value) => {
												if (!value)
													return 'Field is required *';
												if (value.length !== 4)
													return 'Incorrect format';
												const year = Number(value);
												const currentYear =
													new Date().getFullYear();
												const lowestYear = 1800;
												if (year > currentYear)
													return `Year cannot be greater than ${currentYear}`;
												if (year < lowestYear)
													return `Year cannot be less than ${lowestYear}`;
												return true;
											},
										})}
									/>
								</div>
								<CustomSelect
									label="Structure Type"
									name="structureType"
									options={mapSelectOptions(
										options.structureTypeOptions
									)}
									ref={register({
										validate: (value) =>
											value !== '0' ||
											'Field is required *',
									})}
									error={errors.structureType?.message}
									customContainerClass="p4_c1_r2"
								/>
								<CustomSelect
									label="Construction Type"
									name="constructionType"
									options={mapSelectOptions(
										options.constructionTypeOptions
									)}
									ref={register({
										validate: (value) =>
											value !== '0' ||
											'Field is required *',
									})}
									error={errors.constructionType?.message}
									customContainerClass="p4_c2_r2"
								/>
								<div className="p4_c3_r2">
									<CustomInput
										inputName="YearRoofBuilt"
										inputLabel="Year Roof Replaced"
										placeholder="YYYY"
										error={
											errors.YearRoofBuilt &&
											errors.YearRoofBuilt.message
										}
										inputMode="numeric"
										maxLength="4"
										ref={register({
											validate: (value) => {
												if (!value)
													return 'Field is required *';
												if (value.length !== 4)
													return 'Incorrect format';
												const year = Number(value);
												const currentYear =
													new Date().getFullYear();
												const lowestYear = 1800;
												if (year > currentYear)
													return `Year cannot be greater than ${currentYear}`;
												if (year < lowestYear)
													return `Year cannot be less than ${lowestYear}`;
												return true;
											},
										})}
										onBeforeInput={(e) => {
											const char = e.data;
											if (char && !/^\d$/.test(char)) {
												e.preventDefault();
											}
										}}
									/>
								</div>
								<div className={styles.p4_c1_r3_shape}>
									<span className={styles.section_label}>
										Roof Shape
									</span>
									<div>
										<div
											className={
												styles.roof_shape_buttons_container
											}
										>
											<ImageButton
												id="group_1"
												name="Gable"
												label="Gable"
												onClick={changeRoofShapeState}
												shapeName="gable_shape"
												isActive={roofShape === 'Gable'}
											/>
											<ImageButton
												id="group_1"
												name="Hip"
												label="Hip"
												onClick={changeRoofShapeState}
												shapeName="hip_shape"
												isActive={roofShape === 'Hip'}
											/>
											<ImageButton
												id="group_1"
												name="Flat"
												label="Flat"
												onClick={changeRoofShapeState}
												shapeName="flat_shape"
												isActive={roofShape === 'Flat'}
											/>
											<ImageButton
												id="group_1"
												name="Other"
												label="Not Sure"
												onClick={changeRoofShapeState}
												shapeName="other_shape"
												isActive={roofShape === 'Other'}
											/>
										</div>
										<div>
											<span className={styles.error_text}>
												{!!roofShapeError
													? roofShapeError
													: ' '}
											</span>
										</div>
									</div>
								</div>
								<div className={styles.p4_c1_r4}>
									<CustomLabel
										label="Roof Material"
										tooltip="The primary material making up the majority of your roof surface"
									/>
									<div>
										<div
											className={
												styles.roof_material_container
											}
										>
											<ImageButton
												id="group_2"
												name="Asphalt (Composition)"
												label="Asphalt Shingle"
												onClick={
													changeRoofMaterialState
												}
												shapeName="asphalt"
												isActive={
													roofMaterial ===
													'Asphalt (Composition)'
												}
											/>
											<ImageButton
												id="group_2"
												name="Tin (Includes Copper and Steel)"
												label="Metal"
												onClick={
													changeRoofMaterialState
												}
												shapeName="metal"
												isActive={
													roofMaterial ===
													'Tin (Includes Copper and Steel)'
												}
											/>
											<ImageButton
												id="group_2"
												name="Tile (Clay and Hendrix)"
												label="Tile"
												onClick={
													changeRoofMaterialState
												}
												shapeName="tile"
												isActive={
													roofMaterial ===
													'Tile (Clay and Hendrix)'
												}
											/>
											<ImageButton
												id="group_2"
												name="Slate"
												label="Slate"
												onClick={
													changeRoofMaterialState
												}
												shapeName="slate"
												isActive={
													roofMaterial === 'Slate'
												}
											/>
											<ImageButton
												id="group_2"
												name="Rubber Lining"
												label="Rubber Lining"
												onClick={
													changeRoofMaterialState
												}
												shapeName="rubber"
												isActive={
													roofMaterial ===
													'Rubber Lining'
												}
											/>
											<ImageButton
												id="group_2"
												name="Tar and Gravel"
												label="Tar and Gravel"
												onClick={
													changeRoofMaterialState
												}
												shapeName="tar_gravel"
												isActive={
													roofMaterial ===
													'Tar and Gravel'
												}
											/>
											<ImageButton
												id="group_2"
												name="Wood Shingle"
												label="Wood Shingle"
												onClick={
													changeRoofMaterialState
												}
												shapeName="wood_shingle"
												isActive={
													roofMaterial ===
													'Wood Shingle'
												}
												isAlert={true}
											/>
											<ImageButton
												id="group_2"
												name="Asbestos"
												label="Asbestos"
												onClick={
													changeRoofMaterialState
												}
												shapeName="asbestos"
												isActive={
													roofMaterial === 'Asbestos'
												}
												isAlert={true}
											/>
											<ImageButton
												id="group_2"
												name="Other (Roof)"
												label="Other"
												onClick={
													changeRoofMaterialState
												}
												shapeName="other"
												isActive={
													roofMaterial ===
													'Other (Roof)'
												}
											/>
										</div>
										<div>
											<span className={styles.error_text}>
												{!!roofMaterialError
													? roofMaterialError
													: ' '}
											</span>
										</div>
									</div>
								</div>
								<div className="footer">
									<BottomNavigation
										backPath="/"
										backButtonOnClick={onBackButtonClick}
										nextButtonType="submit"
										nextButtonDisabled={
											roofMaterial ===
												forbiddenRoofMaterial ||
											roofMaterial ===
												forbiddenRoofMaterial2
										}
									/>
								</div>
							</div>
						</form>
						<Footer />
					</div>
				</div>
			)}
		</div>
	);
}

export default PropertyInfo_page;
